import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=151065a5&scoped=true"
import script from "./password-reset.vue?vue&type=script&lang=js"
export * from "./password-reset.vue?vue&type=script&lang=js"
import style0 from "./password-reset.vue?vue&type=style&index=0&id=151065a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151065a5",
  null
  
)

export default component.exports